<details-section [title]="'simulationBuilder.SIM_INFORMATION_TITLE' | transloco" [showDetails]="false">
  <avatar-look-voice-selector
    [form]="personaForm"
    [simulationUuid]="callUuid"
    [moduleUuid]="moduleUuid"
    [hideScreenshare]="true"
    [disabled]="readOnly"
    [appearanceLabel]="'simulationBuilder.AVATAR_APPEARANCE_LABEL'"
    (avatarChange)="onAvatarSelected($event)"
    (savedAvatarResolved)="onSavedAvatarResolved($event)"
  >
    <qai-field
      fieldsBefore
      [label]="'simulationBuilder.NAME_LABEL' | transloco"
      [error]="simulationNameErrorKey ? (simulationNameErrorKey | transloco) : ''"
    >
      @if (simulationNameControl) {
        <input qai-input type="text" [formControl]="simulationNameControl" [readonly]="isSimulationNameReadOnly" />
      }
    </qai-field>

    <qai-field fieldsAfter [label]="'simulationBuilder.KNOWLEDGE_CHECK_AVATAR_NAME_LABEL' | transloco">
      @if (avatarNameControl) {
        <input qai-input type="text" [formControl]="avatarNameControl" [readonly]="readOnly" />
      }
    </qai-field>
  </avatar-look-voice-selector>
</details-section>
